import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CustomTooltipComponent } from '../core/custom-tooltip/custom-tooltip.component';
import { HeaderCheckboxComponent } from '../core/grid/header-checkbox/header-checkbox.component';
import { GridRefreshComponent } from '../core/grid/grid-refresh/grid-refresh.component';
import { RowCheckboxComponent } from '../core/grid/row-checkbox/row-checkbox.component';
import {
  checkInvAccess,
  dateFilterComparator,
  getTimezone,
  getUnique,
  getUniqueByKey,
  resetSortingAndFilters,
  validateVanningDates,
  warningMessage,
} from '../constants';
import { GriddataService } from '../services/griddata.service';
import { Subscription, forkJoin } from 'rxjs';
import { OSPStateService } from '../services/osp-state.service';
import { LookupService } from '../services/lookup/lookup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { logErrors } from '../shared/logger';
import * as mm from 'moment-timezone';
import { ExcelService } from '../services/excel.service';
import { ModuleStockingGridCheckboxComponent } from './module-stocking-grid-checkbox.component';
import { ModuleStockingService } from '../services/module-stocking/module-stocking.service';
import { successMessage } from '../constants';
import { AirfreightApicallsService } from '../services/air-freight-validation/airfreight-apicalls.service';
import { RowLinkTapComponent } from './row-link-tap';
import { MatDialogConfig } from '@angular/material/dialog';
import { ContainerTapDialogComponent } from './container-tap-dialog/container-tap-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { from, of } from 'rxjs';
import { concatMap, tap, catchError } from 'rxjs/operators';
import { DefaultService } from '../services/default.service';

@Component({
  selector: 'app-module-stocking-devanning',
  templateUrl: './module-stocking-devanning.component.html',
  styleUrls: ['./module-stocking-devanning.component.scss'],
})
export class ModuleStockingDevanningComponent implements OnInit, OnDestroy {
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('userName');

  @ViewChild('osPartsGrid') osPartsGrid;

  user: string;
  userRole: any;
  offset: number = 0;

  count = 0;
  dataCount: number = 0;
  rowData = [];
  rowDataAirFreight = [];
  columnDefs;
  columnDefsMaster;
  rowSelection;
  context: any;

  gridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = 'true';

  suppressClickEdit = true;
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  tooltipShowDelay = 0;
  editType;
  headerCheckboxChecked: boolean = false;
  isEditMode = false;
  successMessage = '';

  moduleStockingGrid: any;
  warningMessage: string;
  validationMessage : string;

  //Dropdowns

  selectedDock: any = [];
  isControllingModules ={ order_type: 'Controlling Modules', value: true };
  stockingDtFrom: any;
  stockingDtTo: any;
  onInstockingDateFrom: any;
  onInstockingDateTo: any;

  //Dropdowns option
  dockList: any = [];
  easternDate: any;
  defaultPageSize: any = 100000;

  updatedAllRows: boolean =false;
  isStockAll: boolean = false;
  uniqueDock: any = [];
  isAllSelect: boolean = true;
  limit= 8000;
  limitTap= 1000;
  showHideList: any = [
    {
      label: 'Dock',
      value: 'dock',
    },
    {
      label: 'Renban',
      value: 'container_renban',
    },
    {
      label: 'Module',
      value: 'module_number',
    },
    {
      label: 'Plan LO DT',
      value: 'lineoff_date',
    },

    {
      label: 'Plan Stock DT/Time',
      value: 'planned_stocking_datetime',
    },
    {
      label: 'Shift',
      value: 'planned_shift',
    },
    {
      label: 'Plan Veh',
      value: 'planned_vehicle_number',
    },
    // {
    //   label: 'Countdown to next unload',
    //   value: 'vehcountdown',
    // },
    {
      label: 'Stocked',
      value: 'stockCheck',
    },
    // {
    //   label: 'Status',
    //   value: 'module_status',
    // },
    {
      label: 'Actual Stock DT/Time',
      value: 'actual_stocking_datetime',
    },
    // {
    //   label: 'Actual Veh',
    //   value: 'actual_vehicle_number',
    // },
    // {
    //   label: '+/- Veh Stocking',
    //   value: 'vehicle_count_ahead_behind',
    // },
    // {
    //   label: '+/- Module Stocking',
    //   value: 'module_count_ahead_behind',
    // },

    {
      label: 'User',
      value: 'updated_userid',
    },
  ];

  //selectedShowHideList: any = [...this.showHideList];
  selectedShowHideList;
  moduleSubscription$: Subscription;
  ModuleList = [
    { order_type: 'Controlling Modules', value: true },
    { order_type: 'All Modules', value: false }
];
modalComponent = 'modal-component';
access;
accessEdit = false;
accessStockunstockAll = false;

  constructor(
    private readonly gridDataService: GriddataService,
    private readonly stateService: OSPStateService,
    private readonly lookupService: LookupService,
    private readonly spinner: NgxSpinnerService,
    private readonly excelService: ExcelService,
    private readonly OspService: ModuleStockingService,
    private readonly AirfreightApicallsService: AirfreightApicallsService,
    public readonly dialog: MatDialog,
    public readonly defaultService : DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }

  ngOnInit(): void {
      // this.osPartsGrid.gridOptions.columnApi.setColumnVisible('stockCheck', false);
   //}
   this.access = checkInvAccess();
   this.accessEdit = this.access?.functionalityAccess?.edit || false;
   this.accessStockunstockAll = this.access?.functionalityAccess?.stockUnstockAll || false;
 
  if (!this.accessEdit){
    this.showHideList = this.showHideList.filter(item => item.value !== 'stockCheck');    
  }
  this.selectedShowHideList = [...this.showHideList];

    this.columnDefsMaster = [
      {
        headerName: '',
        field: 'rowCheckBox',
        // suppressSorting: true,
        width: 44,
        headerComponentParams: {
          headerChecked: this.headerCheckboxChecked,
        },
        headerComponentFramework: HeaderCheckboxComponent,
        floatingFilterComponentFramework: GridRefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellRendererFramework: RowCheckboxComponent,
        floatingFilter: true,
      },
      {
        headerName: 'Dock',
        field: 'dock',
        width: 70,
        floatingFilter: true,
      },
      {
        headerName: 'Renban',
        field: 'container_renban',
        sortable: true,
        width: 100,
        floatingFilter: true,
        valueGetter: (params) => {
          if (params.data.tap === "TAP"){
            return `${params.data.container_renban}${params.data.module_number}`;
          }else{
            return params.data.container_renban;
          }
        },
      },
      {
        headerName: 'Module',
        field: 'module_number',
        sortable: true,
        width: 90,
        floatingFilter: true,
        cellRendererFramework: RowLinkTapComponent,
        tooltipValueGetter: (params) => {
          const kanban_details = params.data?.kanban_details;
          if (kanban_details === undefined) {
            return `${params.data.module_number}`;
          } else {
            return `${params.data.kanban_details} `;
          }
        },
      },
      {
        headerName: 'Plan LO DT',
        field: 'lineoff_date',
        width: 130,
        headerTooltip: 'LineOff Date(mm/dd/yyyy)',
        filter: 'agDateColumnFilter',
        filterParams: {
          comparator: dateFilterComparator,
        },
        floatingFilter: true,
        comparator: this.dateComparator,
      },
      {
        headerName: 'Plan Stock DT/Time',
        field: 'planned_stocking_datetime',
        width: 150,
        floatingFilter: true,
      },
      {
        headerName: 'Shift',
        field: 'planned_shift',
        sortable: true,
        width: 80,
        floatingFilter: true,
      },
      {
        headerName: 'Plan Veh',
        field: 'planned_vehicle_number',
        width: 100,
        floatingFilter: true,
      },
      // {
      //   headerName: 'Countdown to next unload ',
      //   field: 'vehcountdown',
      //   width: 120,
      //   floatingFilter: true,
      //   hide: true
      // },
      {
        headerName: 'Stocked',
        field: 'stockCheck',
        sortable: false,
        floatingFilter: false,
        cellRendererFramework: ModuleStockingGridCheckboxComponent,
        cellRendererParams: { column: 'stock', onCallAPI: this.onCallAPI.bind(this) },
        width: 80,
        hide: !this.accessEdit
      },
      // {
      //   headerName: 'Status',
      //   field: 'first_controlling_module',
      //   width: 100,
      //   floatingFilter: true,
      //   // hide: 'true',
      // },
      {
        headerName: 'Actual Stock DT/Time',
        field: 'actual_stocking_datetime',
        width: 150,
        floatingFilter: true,
      },
      // {
      //   headerName: 'Actual Veh',
      //   field: 'actual_vehicle_number',
      //   sortable: true,
      //   width: 100,
      //   floatingFilter: true,
      //   hide:true
      // },
      // {
      //   headerName: '+/- Veh Stocking',
      //   field: 'vehicle_count_ahead_behind',
      //   sortable: true,
      //   width: 120,
      //   floatingFilter: true,
      //   hide:true
      // },
      // {
      //   headerName: '+/- Module Stocking',
      //   field: 'module_count_ahead_behind',
      //   sortable: true,
      //   width: 120,
      //   floatingFilter: true,
      //   hide:true
      // },
      {
        headerName: 'Updated DT',
        headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss (Eastern))',
        field: 'updated_date_time',
        sortable: true,
        width: 160,
        floatingFilter: true,
        tooltipField: 'updated_date_time',
      },
      {
        headerName: 'User',
        field: 'updated_userid',
        sortable: true,
        width: 200,
        floatingFilter: true,
        tooltipField: 'updated_userid',
      },
    ];

    this.gridOptions = {
      onSelectionChanged: this.onSelectionChanged.bind(this),
    };
    this.columnDefs = [...this.columnDefsMaster];
    this.setPageSizeToAll(this.defaultPageSize);
    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
    };
    this.moduleSubscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
    });

    this.gridOptions.onFilterChanged = () => {
      let data: any = [];
      if (this.osPartsGrid) {
        this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
          data.push(node.data.dock);
        });
      }
      if (data) {
        this.uniqueDock = getUnique(data, 'dock');
      }
      this.isAllSelected();
    };
  }

  numberComparator(number1, number2) {
    return number1 - number2;
  }

  dateComparator(date1, date2) {
    function monthToNum(date) {
      if (date === undefined || date === null) {
        return null;
      }
      const newDate: Date = new Date(date);
      const yearNumber = newDate.getFullYear();
      const monthNumber = newDate.getMonth();
      const dayNumber = newDate.getDate();
      const hoursNumber = newDate.getHours();
      const minutesNumber = newDate.getMinutes();

      const result = yearNumber * 10000 + monthNumber * 100 + dayNumber + hoursNumber * 60 + minutesNumber * 10;
      return result;
    }

    // To be used inside filter params when using date filter

    const date1Number = monthToNum(date1);
    const date2Number = monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }
  onResetDropDown() {
    this.isAllSelect = true;
    this.removeMessage();
    this.selectedDock = [];
    this.stockingDtFrom = this.onInstockingDateTo;
    this.stockingDtTo = this.easternDate;

    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }
    this.setPageSizeToAll(this.defaultPageSize);

    this.rowData = [];
    this.offset = 0;
    this.isControllingModules ={ order_type: 'Controlling Modules', value: true };
  }
  toggleHeaderCheckbox(checked) {
    if (!checked) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      return;
    }

    const rowCount = this.osPartsGrid.gridOptions.rowData.length;
    const selectedRowCount = this.osPartsGrid.gridOptions.rowData.filter((x) => x.rowCheckBox === true).length;

    if (rowCount === selectedRowCount) {
      this.headerCheckboxChecked = true;
      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
  }

  userCheckChanged(checked, rowIndex) {
    this.spinner.show();
    const rowNode = this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }

  headerCheckChanged(event) {
    this.headerCheckboxChecked = event.checked;
    const headerChecked = event.checked;
    const isEditable = this.isEditMode;
    this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
      if (headerChecked) {
        if (isEditable) {
          rowNode.data.checkedEditMode = true;
        }
        rowNode.data.rowCheckBox = true;
      } else {
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
      }
      rowNode.setData(rowNode.data);
    });
  }
  module_stocking_columns;
  onShowHideChange(ev: any) {
    this.osPartsGrid.gridOptions.columnApi.setColumnsVisible([...this.showHideList.map((e) => e.value)], true);

    const hideItems = this.showHideList.filter((item) => {
      return !ev.value.map((sItem) => sItem.value).includes(item.value);
    });

    this.osPartsGrid.gridOptions.columnApi.setColumnsVisible([...hideItems.map((e) => e.value)], false);

    if (ev.onInit) return;

    this.module_stocking_columns = hideItems;
    if (!hideItems.length) this.module_stocking_columns = [{}];
  }

  onSearch(offset) {
    console.log(this.isControllingModules,"sodkskjkjldkjlsdflkjsd")
    this.uniqueDock = [];
    this.isAllSelected();
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    this.removeMessage();
    if (this.updatedAllRows) {
      this.successMessage = this.isStockAll
        ? successMessage.stockAll + this.uniqueDock
        : successMessage.unstockAll + this.uniqueDock;
    }

    if (offset === 0) {    
      this.setPageSizeToAll(this.defaultPageSize);
      this.rowData = [];
      this.osPartsGrid.gridOptions.api.setRowData(this.rowData);

      const { valid, error } = validateVanningDates({
        vanningFrom: this.stockingDtFrom,
        vanningTo: this.stockingDtTo,
      });

      if (!valid) {
        this.warningMessage = warningMessage.stockingdateInvalid;
        window.scroll(0, 0);
        this.spinner.hide();
        return;
      }

      this.offset = 0;
      this.spinner.show();
    }

    if (!this.checkIfAnySelected()) {
      this.rowData = [];
      //this.warningMessage = warningMessage.selectDock;
      this.warningMessage = this.validationMessage;
      window.scroll(0, 0);
      this.spinner.hide();
      return false;
    }
    let selectedDock;

    if (this.selectedDock.length > 0) {
      if (!this.selectedDock.some((a) => a.dock === 'ALL')) {
        selectedDock = [];
        this.selectedDock.forEach((element) => {
          selectedDock.push(element.dock);
        });
      }
    }

    const data = {
      offset: offset,
      limit: this.limit,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: selectedDock,
      stockingDtFrom: this.stockingDtFrom,
      stockingDtTo: this.stockingDtTo,
      currenteasternDate: this.easternDate,
      controlling: this.isControllingModules.value,
    };

    this.OspService.getmoduleStockingData(data).subscribe({
      error: (error) => this.errorCallback(error,'getmoduleStockingData'),
      next: (res) => {
        if (!res.error) {
          if (res.body && res.body.data) {
            this.rowData.push(...res.body.data);
            this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            console.log('parseInt(res.body.data.rowCount)', this.offset, parseInt(res.body.data));
            this.dataCount = parseInt(res.body.rowCount);
            const records = this.dataCount - (this.offset + 1) * this.limit;
            console.log('records', records);
            if (records >= 1) {
              this.offset++;
              this.onSearch(this.offset * this.limit);
            } else {
              //this.spinner.hide();

              //Call onSearchSchedules function
              this.offset = 0; //reset offset
              this.rowDataAirFreight = [];
              this.onSearchSchedules(0);
              this.updatedAllRows =false;
            }
          } else {
            this.rowData = [];
            //Call onSearchSchedules function
            this.offset = 0; //reset offset
            this.rowDataAirFreight = [];
            this.onSearchSchedules(0);
            //this.spinner.hide();
            this.updatedAllRows =false;

          }

          this.setPageSizeToAll();
        } else {
          this.spinner.hide();
          this.warningMessage = 'Something went wrong! Please contact support team.' + (res.error?.message ? ' | ' + res.error.message : '');
        }
      },
    });

    return true;
  }
  onSearchSchedules(offset) {
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    // this.removeMessage();

    let selectedDock;

    if (this.selectedDock.length > 0) {
      if (!this.selectedDock.some((a) => a.dock === 'ALL')) {
        selectedDock = [];
        this.selectedDock.forEach((element) => {
          selectedDock.push(element.dock);
        });
      }
    }

    const data = {
      offset: offset,
      limit: this.limit,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: selectedDock,
      stockingDtFrom: this.stockingDtFrom,
      stockingDtTo: this.stockingDtTo,
      currenteasternDate: this.easternDate,
    };

    this.AirfreightApicallsService.getModuleSchedules(data).subscribe({
      error: (error) => this.errorCallback(error,'getModuleSchedules'),
      next: (res) => {
        console.log('getModuleSchedules res', res);

        if (res.body && res.body?.addResponse?.data) {          
          //this.rowData.push(...res.body.addResponse.data);
          //console.log('this.rowData', this.rowData, res.body);
          this.rowDataAirFreight.push(...res.body.addResponse.data);          
          this.dataCount = this.dataCount + parseInt(res.body.addResponse?.rowCount);
          const records = parseInt(res.body.addResponse?.rowCount) - (this.offset + 1) * this.limit;
          if (records >= 1) {
            this.offset++;
            this.onSearchSchedules(this.offset * this.limit);
          } else {
            const groupedData = this.getAirScheduledGroupedData(this.rowDataAirFreight);
            this.rowData.push(...groupedData);
            this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            this.offset = 0; //reset offset
            this.onSearchTap(0);
            //this.spinner.hide();
          }
        } else {
          // this.rowData = [];
          const groupedData = this.getAirScheduledGroupedData(this.rowDataAirFreight);
          this.rowData.push(...groupedData);
          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          this.offset = 0; //reset offset
          this.onSearchTap(0);
          //this.spinner.hide();
        }

        this.setPageSizeToAll();
      }/*,
      complete: () => {
        if (this.rowData.length === 0) {
          this.warningMessage = warningMessage.noDataAvailble;
        }
        //this.spinner.hide();
      }*/
    });
    return true;
  }

  onSearchTap(offset){
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();
      this.resetGrid();
    }

    // this.removeMessage();

    let selectedDock;

    if (this.selectedDock.length > 0) {
      if (!this.selectedDock.some((a) => a.dock === 'ALL')) {
        selectedDock = [];
        this.selectedDock.forEach((element) => {
          selectedDock.push(element.dock);
        });
      }
    }

    const data = {
      offset: offset,
      limit: this.limitTap,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      dock: selectedDock,
      stockingDtFrom: this.stockingDtFrom,
      stockingDtTo: this.stockingDtTo,
    };

    // this.spinner.show();
    this.OspService.getContainerTapData(data).subscribe({
      error: (error) => this.errorCallback(error,'getContainerTapData'),
      next: (res) => {
        console.log('getContainerTapData res', res);

        if (res.body && res.body?.data) {
          this.rowData.push(...res.body.data);
          //console.log('this.rowData', this.rowData, res.body);
          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          this.dataCount = this.dataCount + parseInt(res.body.rowCount);
          const records = parseInt(res.body.rowCount) - (this.offset + 1) * this.limitTap;
          if (records >= 1) {
            this.offset++;
            this.onSearchTap(this.offset * this.limitTap);
          } else {
            this.rowData = this.getsortedgridData(this.rowData);
            this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            this.spinner.hide();
          }
        } else {
          this.rowData = [];
          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          this.spinner.hide();
          this.warningMessage = 'Something went wrong! Please contact support team.' + (res.error?.message ? ' | ' + res.error.message : '');
        }

        this.setPageSizeToAll();
      },
      complete: () => {
        if (this.rowData.length === 0) {
          if(!this.warningMessage){
            this.warningMessage = warningMessage.noDataAvailble;
          }
        }
      }
    });
    return true;
  }

  userTapped(rowIndex: number) {
    const rowNode = this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    this.openTapDialog(rowNode);
  }

  openTapDialog(rowNode) {
    
    const data = rowNode.data;
    console.log("tap clicked");
    console.log("data", data)
    // this.successMessage = successMessage.moduleTypeUpdated;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '1000px';
    dialogConfig.data = {
      dock: data.dock,
      business_entity: data.business_entity,
      container_renban: data.container_renban_v,
      module_number: data.module_number_v,
      planned_stocking_datetime : data.planned_stocking_datetime,
      stockingDtFrom : this.stockingDtFrom,
      stockingDtTo : this.stockingDtTo,
      accessEdit : this.accessEdit
    };

    const dialogRef = this.dialog.open(ContainerTapDialogComponent, dialogConfig);    
    const editGetResponse = dialogRef.componentInstance.saveContainerTapEventEmitter.subscribe((retVal) => {
    const {payload, anyStocked} = retVal;   
    console.log("Emission received:", payload); // Add this to check if the event is triggered      
      this.spinner.show();
      this.OspService.updateStockTap(payload).subscribe({
        error:(error) => this.customErrorCallback(error,'updateStockTap'),
        next: (res) => {
          if (res?.error) {
            this.customErrorCallback(res?.error, "updateStockTap");
            window.scroll(0, 0);
          } else {
            if (res.body.updatedRowsTap >= 1) {   
                this.successMessage =  successMessage.recordUpdated;
                rowNode.data.module_status = anyStocked ? 'STOCKED': 'UNSTOCKED';
                if (!anyStocked){
                  rowNode.data.actual_stocking_datetime = null;  
                }
                rowNode.setData(rowNode.data);
            } else {
              this.warningMessage = `${warningMessage.apiLogicFail}.`;
            }
            this.spinner.hide();
            window.scroll(0, 0);
          }
        },
      });
    });
    
  }

  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(Number(this.paginationPageSize));
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;

    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }

    this.onPageSizeChanged();
  }

  getModifiedRowData() {
    return this.rowData.filter((row) => row.rowCheckBox);
  }

  exportAsXLSX(): void {
    this.removeMessage();
    this.spinner.show();

    const easternCurrentDate = String(mm().tz(getTimezone(this.namcValue)).format('YYYY-MM-DD_HH:mm:ss'));

    let data: any[] = [];
    // Collect selected rows from the grid
    if (this.headerCheckboxChecked) {
      this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
        data.push(node.data);
      });
    } else {
      data = this.getModifiedRowData();
    }

    // If no rows are selected, show warning message
    if (data.length < 1) {
      this.spinner.hide();
      this.warningMessage = warningMessage.noRowsSelected;
    } else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];
          data.forEach((e) => {
            const [date, time] = e.planned_stocking_datetime.split(' ');
            const obj = {
              dock: e.dock,
              renban: e.container_renban,
              module: e.module_number,
              planLoDate: e.lineoff_date,
              //planStockDTime: e.planned_stocking_datetime,
              planStockDT : date,
              planStockTime : time,
              plannedShift: e.planned_shift,
              plannedVehicalNumber: e.planned_vehicle_number,
              moduleStatus: e.module_status,
              actualStockDTIME: e.actual_stocking_datetime,
              // actualVehicalNumber: e.actual_vehicle_number,
              // vehStocking: e.vehicle_count_ahead_behind,
              // moduleStocking: e.module_count_ahead_behind,
              userId: e.updated_userid,
            };
            exportData.push(obj);
          });

          const headers = [
            'Dock',
            'Renban',
            'Module',
            'Plan LO DT',
            // 'Plan Stock DT/TIME',
            'Plan Stock DT',
            'Plan Stock TIME',
            'Shift',
            'Plan Veh',
            'Status',
            'Actual Stock DT/TIME',
            // 'Actual Veh',
            // '+/- Veh Stocking',
            // '+/- Module Stocking',
            'User',
          ];

          const timestamp = easternCurrentDate

            .split('.')[0]
            .replace('T', '_')
            .split('')

            .filter((d) => d !== '-' && d !== ':')
            .join('');
          this.excelService.excelModuleStocking(exportData, 'ModuleStocking_' + timestamp, headers);
        }
        this.spinner.hide();
      }, 1000);
    }
  }

  // function for checkbox, stock/unstock
  async onCallAPI(rowData: any): Promise<void> {
    this.updatedAllRows = false;
    this.isStockAll = false;


    if (rowData.container_renban === 'AIRFR') {
      const dataAir = {
        offset: 0,
        limit: this.limit,
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        is_module_status: rowData.stock,
        data: rowData.sched_id,
      };
      if (await this.callingEditAir(dataAir, this.updatedAllRows, this.isStockAll)){
        //this.callOnsearch(this.updatedAllRows,this.isStockAll);
      }
    } else {
      if (rowData.module_number === 'TAP'){
          const isTapStocked = (rowData.module_status === "STOCKED") ? true : false;
          const payload = 
          {
            workid: this.user,
            user_role: this.userRole,
            business_entity: this.namcValue,
            stockAllBetween: (this.stockingDtFrom && this.stockingDtTo) ? true : false, 
            stockAllBlankFrom: !this.stockingDtFrom,
            userid: this.userName,
            unstockAll: !isTapStocked,
            stockingDtFrom:  this.stockingDtFrom, 
            stockingDtTo:  this.stockingDtTo,
            stockItems : [{
              dock : rowData.dock,
              container_renban : rowData.container_renban_v,
              module_number : rowData.module_number_v,
              kanban : JSON.parse(rowData.kanban_list.replace(/'/g, '"')),
              userid : this.userName
            }],
            isCheckBoxEnabled : true, 
            planned_stocking_datetime  :  rowData.planned_stocking_datetime      
          }          
      await this.callStockUnstockContainerTap(payload);      
      }else{
        const data = {
          offset: 0,
          limit: this.limit,
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          is_module_status: rowData.stock,
          userid: this.userName,
          data: [rowData.module_type + ',' + rowData.module_number + ',' + rowData.container_renban + ',' + rowData.dock + ','
           + rowData.first_controlling_module],
        };
        if (await this.callingEditService(data, this.updatedAllRows, this.isStockAll)){
          //this.callOnsearch(this.updatedAllRows,this.isStockAll);
        }
      }
    }
  }

  // edit AP call
  // callingEditService(data, updatedAllRows, isStockAll) {
  //   const batchSize = 300;
  //   const totalBatches = Math.ceil(data.data.length / batchSize);

  //   const processBatch = (batchIndex) => {
  //     const start = batchIndex * batchSize;
  //     const end = Math.min(start + batchSize, data.data.length);
  //     const batchData = data.data.slice(start, end);
  //     const data2 = {
  //       offset: 0,
  //       limit: this.limit,
  //       business_entity: this.namcValue,
  //       workid: this.user,
  //       user_role: this.userRole,
  //       is_module_status: data.is_module_status,
  //       userid: this.userName,
  //       data: batchData,
  //     };

  //     this.OspService.editModuleStocking(data2).subscribe({
  //       error: this.errorCallback,
  //       next: (res) => {
  //         this.spinner.show();

  //         if (res.body && res.body.updatedRows) {
  //           if (!updatedAllRows) {
  //             // this.rowData = res.body.updatedRows;
  //             var updatedRows = res.body.updatedRows;
  //             updatedRows.forEach((updatedRow) => {
  //               const rowNode = this.osPartsGrid.gridOptions.api.getRowNode(updatedRow.id);
  //               if (rowNode) {
  //                 rowNode.data.module_number = updatedRow.module_number;
  //                 rowNode.data.actual_stocking_datetime = updatedRow.actual_stocking_datetime;
  //                 rowNode.data.updated_userid = updatedRow.updated_userid;
  //               }
  //             });

  //             // Assuming this.rowData contains all the rows including the updated ones
  //             this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  //             // if (this.rowData[0].length> 0) {

  //             //   this.successMessage = this.rowData[0].is_module_stocked
  //             //     ? successMessage.stockAll + this.uniqueDock
  //             //     : successMessage.unstockAll + this.uniqueDock;
  //             // }
  //           } else if (batchIndex < totalBatches - 1) {
  //             processBatch(batchIndex + 1);
  //           } else {
  //             console.log('before onsearch >>>>>>>>>>>>>> editModuleStocking');
  //             this.onSearch(0);
  //             // if (updatedAllRows) {
  //             //   this.successMessage = isStockAll
  //             //     ? successMessage.stockAll + this.uniqueDock
  //             //     : successMessage.unstockAll + this.uniqueDock;
  //             // }
  //           }
  //         }
  //       },
  //       complete: () => {
  //         if (batchIndex >= totalBatches - 1) {
  //           window.scroll(0, 0);
  //           this.setPageSizeToAll();
  //           this.spinner.hide();
  //           // this.onSearch(0); // Call onSearch here
  //           // if (updatedAllRows) {
  //           //   this.successMessage = isStockAll
  //           //     ? successMessage.stockAll + this.uniqueDock
  //           //     : successMessage.unstockAll + this.uniqueDock;
  //           // }
  //         }
  //       },
  //     });
  //   };

  //   processBatch(0);
  // }

  // callingEditService(data, updatedAllRows, isStockAll) {
  //   this.OspService.editModuleStocking(data).subscribe({
  //     error: this.errorCallback,
  //     next: (res) => {
  //       this.spinner.hide();

  //       if (res.body && res.body.updatedRows) {
  //         if (!updatedAllRows) {
  //           const selectedRowNodes = this.osPartsGrid.gridOptions.api.getSelectedNodes();
  //           const selectedIds = selectedRowNodes.map(function (rowNode) {
  //             return rowNode.id;
  //           });
  //           this.rowData = this.rowData.map(function (dataItem) {
  //             const itemSelected = selectedIds.indexOf(dataItem.symbol) >= 0;
  //             if (itemSelected) {
  //               return {
  //                 module_number: res.body.updatedRows.module_number,
  //                 actual_stocking_datetime: dataItem.actual_stocking_datetime,
  //                 updated_userid: dataItem.updated_userid,
  //               };
  //             } else {
  //               return dataItem;
  //             }
  //           });
  //           this.osPartsGrid?.gridOptions.api.setGridOption('rowData', this.rowData);
  //         } else {
  //           this.onSearch(0);
  //           if (isStockAll) {
  //             this.successMessage = successMessage.stockAll + this.uniqueDock;
  //           } else {
  //             this.successMessage = successMessage.unstockAll + this.uniqueDock;
  //           }
  //         }
  //       }
  //       window.scroll(0, 0);
  //       this.setPageSizeToAll();
  //     },
  //   });
  // }

  // callingEditAir(data, updatedAllRows, isStockAll): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     this.AirfreightApicallsService.updateAirModule(data).subscribe({
  //       next: (res) => {
  //         console.log('callingEditAir res', res);
  
  //         if (res.body) {
  //           if (!updatedAllRows) {
  //             const selectedRowNodes = this.osPartsGrid.gridOptions.api.getSelectedNodes();
  //             const selectedIds = selectedRowNodes.map((rowNode) => rowNode.id);
  
  //             this.rowData = this.rowData.map((dataItem) => {
  //               const itemSelected = selectedIds.indexOf(dataItem.symbol) >= 0;
  //               if (itemSelected) {
  //                 return {
  //                   module_number: res.body.updatedRows.module_number,
  //                   actual_stocking_datetime: dataItem.actual_stocking_datetime,
  //                   updated_userid: dataItem.updated_userid,
  //                 };
  //               } else {
  //                 return dataItem;
  //               }
  //             });
  
  //             this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  //           }
  //         }
  
  //         window.scroll(0, 0);
  //         this.setPageSizeToAll();
  //         this.onSearch(0);
  
  //         if (updatedAllRows) {
  //           this.successMessage = isStockAll
  //             ? successMessage.stockAll + this.uniqueDock
  //             : successMessage.unstockAll + this.uniqueDock;
  //         }
  
  //         resolve(); // signal success
  //       },
  //       error: (err) => {
  //         this.errorCallback(err);
  //         reject(err); // signal failure
  //       },
  //     });
  //   });
  // }

  // callStockUnstockContainerTap(payload, updatedAllRows, isStockAll){
  //   this.spinner.show();
  //   this.OspService.stockAllUnstockAll(payload).subscribe({
  //     error: this.errorCallback,
  //     next: (res) => {
  //       if (res?.error) {
  //         this.customErrorCallback(res?.error, "update Stock Tap");
  //         window.scroll(0, 0);
  //       } else {
  //         if (res.body.updatedRowsTap >= 1) {   
  //           this.setPageSizeToAll();
  //           console.log('before onsearch >>>>>>>>>>>>>> callStockUnstockContainerTap');
  //           this.onSearch(0); // Call onSearch here
  //           if (updatedAllRows) {
  //             this.warningMessage = "";
  //             this.successMessage = isStockAll
  //               ? successMessage.stockAll + this.uniqueDock
  //               : successMessage.unstockAll + this.uniqueDock;
  //           }
  //         } 
  //         this.spinner.hide();
  //         window.scroll(0, 0);
  //       }
  //     },
  //   });
  // }
  
  callingEditService(data, updatedAllRows, isStockAll): Promise<boolean> {
    const batchSize = 300;
    const batches = [];
  
    for (let i = 0; i < data.data.length; i += batchSize) {
      const batchData = data.data.slice(i, i + batchSize);
      const data2 = {
        offset: 0,
        limit: this.limit,
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        is_module_status: data.is_module_status,
        userid: this.userName,
        data: batchData,
      };
      batches.push(data2);
    }
  
    return new Promise((resolve, reject) => {
      from(batches)
        .pipe(
          concatMap((batch, index) =>
            this.OspService.editModuleStocking(batch).pipe(
              tap((res: any) => {
                //this.spinner.show();
                const updatedRows = res.body?.updatedRows || [];
  
                if (!updatedAllRows) {
                  updatedRows.forEach((updatedRow) => {
                    //const rowNode = this.osPartsGrid.gridOptions.api.getRowNode(updatedRow.id);
                    const rowNode = this.getRowNodebyColumnValue(updatedRow, "modulestocking");                    
                    if (rowNode) {
                      const excludedKeys = ['module_type', 'module_number', 'container_renban', 'dock'];
                      for (const key in updatedRow) {
                        if (
                          updatedRow.hasOwnProperty(key) &&
                          !excludedKeys.includes(key) &&
                          rowNode.data[key] !== updatedRow[key]
                        ) {
                          rowNode.data[key] = updatedRow[key];
                        }
                      }
                      rowNode.setData(rowNode.data);
                      this.checkIfPreviousModuleStocked(rowNode.data);
                    }
                  });
                  //this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
                } else if (index === batches.length - 1) {
                  //this.onSearch(0); // last batch completed
                }
              }),
              catchError((err) => {
                this.errorCallback(err,"callingEditService");
                console.log(err);
                reject(false); // stop on first error
                return of(null); // stop further processing
              })
            )
          )
        )
        .subscribe({
          complete: () => {
            // this.setPageSizeToAll();
            // this.spinner.hide();
            // window.scroll(0, 0);
            resolve(true); // All batches completed
          },
        });
    });
  }

  callingEditAir(data, updatedAllRows, isStockAll): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.AirfreightApicallsService.updateAirModule(data).subscribe({
        next: (res) => {
          console.log('callingEditAir res', res);
  
          if (res.body) {
            if (!updatedAllRows) {
              // const selectedRowNodes = this.osPartsGrid.gridOptions.api.getSelectedNodes();
              // const selectedIds = selectedRowNodes.map((rowNode) => rowNode.id);
  
              // this.rowData = this.rowData.map((dataItem) => {
              //   const itemSelected = selectedIds.indexOf(dataItem.symbol) >= 0;
              //   if (itemSelected) {
              //     return {
              //       module_number: res.body.updatedRows.module_number,
              //       actual_stocking_datetime: dataItem.actual_stocking_datetime,
              //       updated_userid: dataItem.updated_userid,
              //     };
              //   } else {
              //     return dataItem;
              //   }
              // });

              const updatedRows = res.body?.addResponse?.updatedRows?.data || [];
              const groupedData = this.getAirScheduledGroupedData(updatedRows); 
              groupedData.forEach((updatedRow) => {
                //const rowNode = this.osPartsGrid.gridOptions.api.getRowNode(updatedRow.id);
                const rowNode = this.getRowNodebyColumnValue(updatedRow, "airfreight");                    
                if (rowNode) {
                  const excludedKeys = ['module_number', 'container_renban', 'dock', 'planned_stocking_datetime', 'lineoff_date', 'module_status'];
                  for (const key in updatedRow) {
                    if (
                      updatedRow.hasOwnProperty(key) &&
                      !excludedKeys.includes(key) &&
                      rowNode.data[key] !== updatedRow[key]
                    ) {
                      rowNode.data[key] = updatedRow[key];
                    }
                  }
                  rowNode.setData(rowNode.data);
                }
              });                
              //this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
            }
          }
  
          // window.scroll(0, 0);
          // this.setPageSizeToAll();
          // //this.onSearch(0);
  
          // if (updatedAllRows) {
          //   this.successMessage = isStockAll
          //     ? successMessage.stockAll + this.uniqueDock
          //     : successMessage.unstockAll + this.uniqueDock;
          // }
  
          resolve(true); // signal success
        },
        error: (err) => {
          this.errorCallback(err,"callingEditAir");
          console.log(err);
          reject(false); // signal failure
        },
      });
    });
  }
  
  callStockUnstockContainerTap(payload): Promise<boolean> {
    //this.spinner.show();
    return new Promise((resolve, reject) => {
      this.OspService.stockAllUnstockAll(payload).subscribe({
        next: (res) => {
          if (res?.error) {
            this.customErrorCallback(res?.error, "stockAllUnstockAll");
            window.scroll(0, 0);
            this.spinner.hide();
            console.log(res?.error);
            reject(false); // signal failure
          } else {
            if (res.body.updatedRowsTap >= 1 && payload.isCheckBoxEnabled && Array.isArray(res.body.updatedRowsData)) {
              res.body.updatedRowsData.forEach((updatedRow) => {
                const rowNode = this.getRowNodebyColumnValue(updatedRow, "tap");
                if (rowNode) {
                  const excludedKeys = ['business_entity', 'container_renban', 'container_renban_v', 'module_number', 'module_number_v', 'dock'];
                  for (const key in updatedRow) {
                    if (
                      updatedRow.hasOwnProperty(key) &&
                      !excludedKeys.includes(key) &&
                      rowNode.data[key] !== updatedRow[key]
                    ) {
                      rowNode.data[key] = updatedRow[key];
                    }
                  }
                  rowNode.setData(rowNode.data);
                }
              });
            }
            resolve(true); // signal success
          }
        },
        error: (err) => {
          //this.spinner.hide();
          this.errorCallback(err,"stockAllUnstockAll");
          console.log(err);
          reject(false);
        },
      });
    });
  }

  callOnsearch(updatedAllRows,isStockAll){
    this.setPageSizeToAll();
    this.spinner.hide();
    window.scroll(0, 0);
    this.onSearch(0);
    if (updatedAllRows) {
      this.successMessage = isStockAll
        ? successMessage.stockAll + this.uniqueDock
        : successMessage.unstockAll + this.uniqueDock;
    }
  }
  
  async stockUnstockAll(isStockAll: boolean) {
    this.updatedAllRows = true;
    this.isStockAll = isStockAll;
    let allData = [];
    let allDataTap = [];
    allData = this.getModifiedcheckedRowData(isStockAll);
    allDataTap = this.getModifiedcheckedRowTapData(isStockAll);
    let success = false;

    if (allData.length < 1 && allDataTap.length < 1) {
      if (isStockAll) {
        this.warningMessage = 'All the records in grid are in stock.';
      } else {
        this.warningMessage = 'All the records in grid are in unstock.';
      }
      window.scroll(0, 0);
      return false;
    }


    const airRecords = allData.filter((row) => row.container_renban === 'AIRFR');
    const noAirRecords = allData.filter((row) => row.container_renban !== 'AIRFR');

    if (noAirRecords.length > 0) {
      //  let arrayData =  noAirRecords.map((record) => ({
      //     module_type: record.module_type,
      //     module_number: record.module_number,
      //     container_renban: record.container_renban,
      //     dock: record.dock
      //   }))
      let arrayData = noAirRecords.map(
        (record) => record.module_type + ',' + record.module_number + ',' + record.container_renban + ',' + record.dock + ',' + record.first_controlling_module
      );
      const data = {
        offset: 0,
        limit: this.limit,
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        is_module_status: isStockAll,
        userid: this.userName,
        data: arrayData,
      };
      this.spinner.show()
      success = await this.callingEditService(data, this.updatedAllRows, isStockAll);
    }
    if (airRecords.length > 0) {
      const dataAir = {
        offset: 0,
        limit: this.limit,
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        is_module_status: isStockAll,
        userid: this.userName,
        //data: airRecords.map((record) => record.sched_id),
        data: airRecords.reduce((acc, record) => acc.concat(record.sched_id), [])
      };
      this.spinner.show()
      success = await this.callingEditAir(dataAir, this.updatedAllRows, isStockAll);
    }
    //start by prasun for container tap  
    
    /*
    if (allDataTap.length > 0){
      const payload = 
          {
            workid: this.user,
            user_role: this.userRole,
            business_entity: allDataTap[0].business_entity,
            stockAllBetween: (this.stockingDtFrom && this.stockingDtTo) ? true : false, 
            stockAllBlankFrom: !this.stockingDtFrom,
            userid: this.userName,
            unstockAll: !this.isStockAll,
            stockingDtFrom:  this.stockingDtFrom, 
            stockingDtTo:  this.stockingDtTo,
            stockItems : allDataTap.map( m => ({
              dock : m.dock,
              container_renban : m.container_renban_v,
              module_number : m.module_number_v,
              kanban : JSON.parse(m.kanban_list.replace(/'/g, '"')),
              userid : this.userName
            }))
          }  
        this.spinner.show()  
        success =   await this.callStockUnstockContainerTap(payload);
    }
*/
    if (allDataTap.length > 0) {
      console.log('allDataTap',allDataTap);
      const chunkSize = 20;
  
      // Loop in steps of chunkSize
      for (let i = 0; i < allDataTap.length; i += chunkSize) {
          const chunk = allDataTap.slice(i, i + chunkSize);
  
          const payload = {
              workid: this.user,
              user_role: this.userRole,
              business_entity: chunk[0].business_entity,
              stockAllBetween: (this.stockingDtFrom && this.stockingDtTo) ? true : false,
              stockAllBlankFrom: !this.stockingDtFrom,
              userid: this.userName,
              unstockAll: !this.isStockAll,
              stockingDtFrom: this.stockingDtFrom,
              stockingDtTo: this.stockingDtTo,
              stockItems: chunk.map(m => ({
                  dock: m.dock,
                  container_renban: m.container_renban_v,
                  module_number: m.module_number_v,
                  kanban: JSON.parse(m.kanban_list.replace(/'/g, '"')),
                  userid: this.userName
              }))
          };
  
          this.spinner.show();
          success = await this.callStockUnstockContainerTap(payload);
  
          // Optional: handle response before moving to next chunk
          if (!success) {
              console.error(`Chunk starting at index ${i} failed.`);
              this.spinner.hide();
              break; // or continue, based on your needs
          }
      }      
  }

    if (success){
      this.callOnsearch(this.updatedAllRows, isStockAll);
    }
    //end by prasun for container tap
  }

  // Method to check condition stockAll/unStock button will be visible
  isAllSelected() {
    const isAllSelectedCondition =
      this.selectedDock.length === 0 ||
      this.uniqueDock.length > 1 ||
      (this.uniqueDock.length === 0 && this.selectedDock.some((dock) => dock.dock === 'ALL')) ||
      (this.selectedDock.length > 1 && this.uniqueDock.length !== 1) ||

      //this.stockingDtFrom != this.stockingDtTo;
      this.stockingDtFrom ||
      !this.stockingDtTo;
    console.log('this.selectedDock', this.selectedDock, 'this.uniqueDock', this.uniqueDock);


    console.log('isAllSelectedCondition', isAllSelectedCondition, this.stockingDtFrom, this.stockingDtTo);

    this.isAllSelect = isAllSelectedCondition;
  }

  getModifiedcheckedRowData(isStockAll: boolean) {
    let data: any = [];
    this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
      data.push(node.data);
    });
    console.log('data----', data);

    if (isStockAll) {
      return data.filter(
        (row) =>
          (row.module_status === 'UNSTOCKED' ||
          row.module_status === null ||
          row.module_status === '' ||
          (row.stockCheck && row.stockCheck.isChecked === false))
          && row.module_number !== 'TAP'
      );
    } else {
      return data.filter(
        (row) => (row.module_status === 'STOCKED' && (!row.stockCheck || row.stockCheck.isChecked !== false)) && row.module_number !== 'TAP'
      );
    }
  }

  getModifiedcheckedRowTapData(isStockAll: boolean) {
    let data: any = [];
    this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
      data.push(node.data);
    });
    console.log('data----', data);

    if (isStockAll) {
      return data.filter(
        (row) =>
          (row.module_status === 'UNSTOCKED' ||
          row.module_status === null ||
          row.module_status === '')
          && row.module_number === 'TAP'
      );
    } else {
      return data.filter(
        (row) => (row.module_status === 'STOCKED') && row.module_number === 'TAP'
      );
    }
  }

  ngOnDestroy(): void {
    this.moduleSubscription$.unsubscribe();
  }

  initializeData() {
    this.spinner.show();
    this.rowData = [];

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    if (localStorage.getItem('UserName')) {
      this.userName = localStorage.getItem('UserName');
    }


    this.loadDrop();

    this.onResetDropDown();

    // eastern time api
    // this.lookupService.getEasternDate().subscribe({
    //   error:(error) => this.errorCallback(error,'getEasternDate'),
    //   next: (res) => {
    //     this.stockingDtTo = res.body.data;
    //     this.easternDate = res.body.data;
    //   },
    // });
    this.stockingDtTo = String(mm().tz(getTimezone(this.namcValue)).format()).substring(0,10);
    this.easternDate = String(mm().tz(getTimezone(this.namcValue)).format()).substring(0,10);
  }

  checkIfAnySelected() {
    this.validationMessage = '';
    const msgPrefix = 'Please select '
    let msgArr = [];

    if (this.selectedDock){
      if (Object.keys(this.selectedDock).length === 0){
        msgArr.push('Dock');
      }
    }else{
      msgArr.push('Dock');
    }

    if (!this.stockingDtTo){
      msgArr.push('Stocking Dt To');
    }

    if (msgArr.length > 0){
      this.validationMessage = `${msgPrefix}${msgArr.join(', ')}.`;
      return false;
    }
    return true;
    // if (this.selectedDock.length > 0) {
    //   return true;
    // }
    // return false;
  }

  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);
      return;
    }
  }

  errorCallback = (error,apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if(error?.error?.message){
      backendMessage = error.error.message;
    } else if(error?.message){
      backendMessage = error.message;
    }
    if(backendMessage){
      detailedMessage += `| ${backendMessage}`;
      if(apiName){
        detailedMessage += `| Error in ${apiName}`;
      }
    } else if(apiName){
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };

  customErrorCallback = (error,apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if(error?.error?.message){
      backendMessage = error.error.message;
    } else if(error?.message){
      backendMessage = error.message;
    }
    if(backendMessage){
      detailedMessage += `| ${backendMessage}`;
      if(apiName){
        detailedMessage += `| Error in ${apiName}`;
      }
    } else if(apiName){
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };

  // Service call
  loadDrop() {
    this.spinner.show();

    const data = {
      offset: this.offset,
      limit: this.limit,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      stocking_to: this.stockingDtTo,
      stocking_from: this.stockingDtFrom,
      currenteasternDate: this.easternDate,
    };

    const lookupSubscriptions = [this.lookupService.getDock(), this.lookupService.getUserShowHideColumns()];

    forkJoin(lookupSubscriptions).subscribe({
      next: (res) => {
        this.dockList = [];
        if (!res[0].error) {
          if (res[0].body.data) {
            this.dockList.push({ dock: 'ALL' });
          }
        } else {
          this.warningMessage = 'Try after some time! Error in get dock list';
        }
        this.dockList.push(...res[0].body.data);
        const { module_stocking_columns } = res[1].body.showHideColumnsResponse;
        try {
          const hideItems = JSON.parse(module_stocking_columns);

          if (typeof hideItems === 'object' && hideItems.length > 0) {
            this.selectedShowHideList = this.showHideList.filter(
              (sItem) => !hideItems.map((item) => item.value).includes(sItem.value)
            );

            this.onShowHideChange({
              value: this.selectedShowHideList,
              onInit: true,
            });
          }
        } catch (error) {}
        if (this.assignDefaultDock()){
          this.dockChange();
        }
        this.spinner.hide();
      },
      error: (error) => this.errorCallback(error),
    });
  }
  saveShowHide() {
    this.spinner.show();

    let module_stocking_columns = this.module_stocking_columns;
    if (module_stocking_columns) {
      this.lookupService.updateUserShowHideColumns({ module_stocking_columns }).subscribe({
        error: (error) => this.errorCallback(error,'updateUserShowHideColumns'),
        next: (res) => {
          this.spinner.hide();
        },
      });
    } else {
      this.spinner.hide();
    }
  }

  dockChange(): void {   
    if (this.selectedDock.length >= 1) {
      if (this.selectedDock[this.selectedDock.length - 1].dock === 'ALL') {
        this.selectedDock = [];
        this.selectedDock.push(this.dockList[0]);
      } else {
        let indexAll = this.selectedDock.findIndex((data) => data.dock === 'ALL');

        if (indexAll > -1) {
          this.selectedDock.splice(indexAll, 1);
        }
      }
    }
    this.defaultService.setDockCode(JSON.stringify(this.selectedDock));
  }  

  assignDefaultDock(){
    try {
      if (this.dockList?.length > 0){
        const defaultdockArray : any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.selectedDock = this.dockList.filter(item => validDocks.has(item.dock));
          if (this.selectedDock && this.selectedDock.length > 0){
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock',error);
      return false;
    }
  }

  onSelectionChanged() {
    const selectedRows = this.gridOptions.api.getSelectedRows();
    const allRows = [];
    this.gridOptions.api.forEachNode((node) => {
      allRows.push(node.data);
    });
  }

  onRowChanged(event) {
    const changedRows = event.api.getSelectedRows();
  }

  getRowNodebyColumnValue(params: any, param2: string) {
    const api = this.osPartsGrid.gridOptions.api;

    let targetRowNode: any = null;

    api.forEachNode((rowNode) => {
      const data = rowNode.data;

      if (param2 === "modulestocking") {
        if (
          data.module_type === params.module_type &&
          data.module_number === params.module_number &&
          data.container_renban === params.container_renban &&
          data.dock === params.dock
        ) {
          targetRowNode = rowNode;
        }
      } else if (param2 === "airfreight") {
        if (
          //data.sched_id === params.sched_id
          data.module_number === params.module_number &&
          data.container_renban === params.container_renban &&
          data.dock === params.dock &&
          data.planned_stocking_datetime === params.planned_stocking_datetime &&
          data.lineoff_date === params.lineoff_date &&
          data.module_status === params.module_status
        ) {
          targetRowNode = rowNode;
        }
      }
      else if (param2 === "tap") {
        if (
          data.business_entity === params.business_entity &&
          data.dock === params.dock && 
          data.container_renban === params.container_renban &&
          data.container_renban_v === params.container_renban_v &&
          data.module_number_v === params.module_number_v &&
          data.module_number === "TAP"
        ) {
          targetRowNode = rowNode;
        }
      }
    });
    return targetRowNode;
  }

getsortedgridData(data) {
  return data.sort((a, b) => {
    const getSortKeys = (item) => {
      const isTap = item.module_number === 'TAP';
      const container = isTap ? (item.container_renban_v || '') : (item.container_renban || '');

      // Prefer numeric module_seq, else fallback to module_number logic
      let moduleValue: number | string;
      if (item.module_seq !== undefined && item.module_seq !== null && item.module_seq !== '') {
        moduleValue = Number(item.module_seq);
      } else {
        let fallbackModule = isTap ? (item.module_number_v || '') : (item.module_number || '');
        moduleValue = typeof fallbackModule === "string" ? fallbackModule.trim() : fallbackModule;
      }

      const dateStr = item.planned_stocking_datetime;
      const date = dateStr ? new Date(dateStr) : new Date(0);

      return [date, item.dock || '', container.trim(), moduleValue];
    };

    const [dateA, dockA, containerA, moduleA] = getSortKeys(a);
    const [dateB, dockB, containerB, moduleB] = getSortKeys(b);

    // Compare step by step
    if (dateA.getTime() - dateB.getTime() !== 0) return dateA.getTime() - dateB.getTime();
    if (dockA.localeCompare(dockB) !== 0) return dockA.localeCompare(dockB);
    if (containerA.localeCompare(containerB) !== 0) return containerA.localeCompare(containerB);

    // Compare last field
    if (typeof moduleA === 'number' && typeof moduleB === 'number') {
      return moduleA - moduleB;
    }
    return String(moduleA).localeCompare(String(moduleB));
  });
}

  checkIfPreviousModuleStocked(selectedData : any){
    if (!selectedData.is_module_stocked){
      this.warningMessage = "";
      return;
    }
    let valRowData = this.rowData.filter(f => f.dock === selectedData.dock);
    if (valRowData && valRowData.length > 0){
      valRowData =  this.getsortedgridData(valRowData);
      for (const row of valRowData) {
          if (selectedData.container_renban === row.container_renban && selectedData.module_number === row.module_number) {
            break;
          //} else if (row.module_status === "UNSTOCKED" && selectedData.container_renban !== row.container_renban) {
          }else if (row.module_status === "UNSTOCKED") {
            this.successMessage = "";
            this.warningMessage = warningMessage.previousModuleStocked(selectedData.container_renban, selectedData.module_number);    
            // window.scroll(0,0);
            break;
          }
      }	
    }
  }



  getAirScheduledGroupedData(data : any[]) {
    const grouped = {};

    data.forEach((item : any )=> {
        // Clean and normalize grouping keys
        const dock = (item.dock || 'NULL').trim();
        const container_renban = (item.container_renban || 'NULL').trim();
        const module_number = (item.module_number || 'NULL').trim();
        const planned_stocking_datetime = (item.planned_stocking_datetime || 'NULL').trim();
        const lineoff_date = (item.lineoff_date || 'NULL').trim();
        const module_status = (item.module_status || 'NULL').trim();

        const key = [dock, container_renban, module_number, planned_stocking_datetime, lineoff_date, module_status].join('|');

        if (!grouped[key]) {
            grouped[key] = {
                sched_id: [],
                kanban_details: [],
                module_number,
                module_status,
                lineoff_date,
                dock,
                container_renban,
                updated_userid: '',
                actual_stocking_datetime: null,
                planned_stocking_datetime,
                updated_date_time: null
            };
        }

        const group = grouped[key];
        group.sched_id.push(...item.sched_id.split(',').map(s => s.trim()));
        group.kanban_details.push(item.kanban_details);

        // updated_userid: keep lexicographically max
        if (!group.updated_userid || item.updated_userid.trim() > group.updated_userid.trim()) {
          group.updated_userid = item.updated_userid; // assign original, compare trimmed
        }

        // actual_stocking_datetime: keep latest
        if (item.actual_stocking_datetime && (!group.actual_stocking_datetime || new Date(item.actual_stocking_datetime) > new Date(group.actual_stocking_datetime))) {
            group.actual_stocking_datetime = item.actual_stocking_datetime;
        }

        // updated_date_time: keep latest
        if (item.updated_date_time && (!group.updated_date_time || new Date(item.updated_date_time) > new Date(group.updated_date_time))) {
            group.updated_date_time = item.updated_date_time;
        }
    });

    // Final formatting
    return Object.values(grouped).map((g : any) => ({
        sched_id: g.sched_id.flat(),
        module_number: g.module_number,
        module_status: g.module_status,
        kanban_details: g.kanban_details && g.kanban_details.some(v => v?.toString().trim()) ? g.kanban_details.join(', ') : null,
        lineoff_date: g.lineoff_date,
        dock: g.dock,
        container_renban: g.container_renban,
        updated_userid: g.updated_userid,
        actual_stocking_datetime: g.actual_stocking_datetime,
        planned_stocking_datetime: g.planned_stocking_datetime,
        updated_date_time: g.updated_date_time
    }));
}


 

}
